import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AuthForm from './AuthForm';
import AuthManager from '../../../services/dashboard/AuthManager';

export default function ChangePassword() {
  const [form, setForm] = useState({ password: '', confirmPassword: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const identifier = location.state?.identifier; // email passed from OTP verify step

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    setSuccess('');
  
    if (!identifier) {
      setError('Something went wrong. Please start the process again.');
      return navigate('/forgot-password');
    }
  
    if (form.password !== form.confirmPassword) {
      setError('Passwords do not match');
      return;
    }
  
    try {
      setLoading(true);
      const res = await AuthManager.resetPassword(identifier, form.password);
  
      if (res.errorCode) {
        setError(res.responseMessage || 'Failed to reset password');
      } else {
        setSuccess(res.responseMessage || 'Password changed successfully');
        setTimeout(() => navigate('/login'), 2000); // redirect after success
      }
  
    } catch (err) {
      setError('Network error, please try again');
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <AuthForm title="New Password" imageSrc="/images/set new pass img.svg">
      <form className="space-y-4 max-w-md mx-auto" onSubmit={handleSubmit}>
        {error && <div className="text-red-500 text-sm">{error}</div>}
        {success && <div className="text-green-600 text-sm">{success}</div>}

        <input
          type="password"
          name="password"
          placeholder="Enter New Password"
          value={form.password}
          onChange={handleChange}
          required
          className="w-full border border-[#FF7236] rounded px-4 py-2 focus:outline-none focus:border-[#FF7236]"
        />
        <input
          type="password"
          name="confirmPassword"
          placeholder="Confirm New Password"
          value={form.confirmPassword}
          onChange={handleChange}
          required
          className="w-full border border-[#FF7236] rounded px-4 py-2 focus:outline-none focus:border-[#FF7236]"
        />

        <button
          type="submit"
          disabled={loading}
          className="w-full bg-[#FF7236] hover:bg-[#EB5E22] text-white py-2 rounded disabled:opacity-50"
        >
          {loading ? 'Changing...' : 'Change Password'}
        </button>
      </form>
    </AuthForm>
  );
}
